// A short, melodic 5-note acoustic-piano jingle for the "All done!" reveal.
// Synthesised with the Web Audio API — no audio file required.

let ctx = null;

// A piano-ish note: fundamental + a couple of quieter harmonics with a
// fast attack and an exponential decay (that plucky, mellow acoustic feel).
function pianoNote(audio, freq, startAt, dur, gain = 0.5) {
  const harmonics = [
    { mult: 1, amp: 1.0 },
    { mult: 2, amp: 0.28 },
    { mult: 3, amp: 0.12 },
  ];
  const env = audio.createGain();
  env.connect(audio.destination);

  const t0 = startAt;
  env.gain.setValueAtTime(0.0001, t0);
  env.gain.exponentialRampToValueAtTime(gain, t0 + 0.012); // quick attack
  env.gain.exponentialRampToValueAtTime(0.0001, t0 + dur); // natural decay

  harmonics.forEach(({ mult, amp }) => {
    const osc = audio.createOscillator();
    const og = audio.createGain();
    osc.type = "triangle";
    osc.frequency.value = freq * mult;
    og.gain.value = amp;
    osc.connect(og).connect(env);
    osc.start(t0);
    osc.stop(t0 + dur + 0.05);
  });
}

// sol – do – mi – sol – mi  (an upward climb that lands home). Whistleable.
const G4 = 392.0, C5 = 523.25, E5 = 659.25, G5 = 783.99;
const MELODY = [
  { f: G4, at: 0.0,  d: 0.22, g: 0.5 },
  { f: C5, at: 0.17, d: 0.22, g: 0.5 },
  { f: E5, at: 0.34, d: 0.22, g: 0.5 },
  { f: G5, at: 0.51, d: 0.28, g: 0.55 },
  { f: E5, at: 0.74, d: 0.75, g: 0.5 },
];

export function playDoneJingle() {
  try {
    if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();
    const start = ctx.currentTime + 0.04;
    MELODY.forEach((n) => pianoNote(ctx, n.f, start + n.at, n.d, n.g));
  } catch {
    /* audio not available — silently skip */
  }
}
